import React, { useEffect, useRef } from "react";

export default function ConfirmPopover({ show, target, message, onConfirm, onCancel }) {
    const popoverRef = useRef(null);

    useEffect(() => {
        if (show && target) {
            positionPopover();
            document.addEventListener("click", handleOutsideClick);
        } else {
            document.removeEventListener("click", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [show, target]);

    const handleOutsideClick = (e) => {
        if (
            popoverRef.current &&
            !popoverRef.current.contains(e.target) &&
            e.target !== target
        ) {
            onCancel();
        }
    };

    const positionPopover = () => {
        if (!target || !popoverRef.current) return;

        const rect = target.getBoundingClientRect();
        const pop = popoverRef.current;
        console.log(rect, window.scrollY, window.scrollX);

        pop.style.top = `${rect.bottom + window.scrollY + 5}px`;
        pop.style.left = `${rect.left - 250}px`;
    };

    if (!show) return null;

    return (
        <div
            ref={popoverRef}
            className="popover bottom"
            style={{
                position: "absolute",
                display: "block",
                zIndex: 9999
            }}
        >
            <div className="arrow"></div>
            <div className="popover-content">
                <p style={{ marginBottom: "10px" }}>{message}</p>
                <button className="btn btn-xs btn-primary" onClick={onConfirm}>Yes</button>
                <button
                    className="btn btn-xs btn-default"
                    style={{ marginLeft: "5px" }}
                    onClick={onCancel}
                >
                    No
                </button>
            </div>
        </div>
    );
}
